<template>
    <div class="container" id="app">
      <router-view v-if="isTracking"/>
      <div v-else class="space-y-4 max-w-300 mx-auto px-2 lg:px-0">
        <static-header/>
        <div class="pt-2 pb-4">
          <breadcrumb />
          <router-view/>
        </div>
        <static-footer/>
      </div>
      <noscript><iframe :src="`https://www.googletagmanager.com/ns.html?id=${tagManager}`" height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
    </div>
</template>

<script>
import Breadcrumb from './components/Static/Breadcrumb'
import StaticHeader from './components/Static/Header'
import StaticFooter from './components/Static/Footer'

export default {
  name: 'app',
  components: {
    Breadcrumb,
    StaticHeader,
    StaticFooter
  },

  data () {
    return {
      isTracking: this.$route.path === '/tracking',
      tagManager: process.env.VUE_APP_TAG_MANAGER
    }
  }
}
</script>
